import {ProcedureComment} from './query'

// ReviewCommentsコンポーネントへの入力用にキーをsnake_caseに変換
export const decamelizeComments = (comments: ProcedureComment[]) =>
  comments.map((c) => ({
    id: c.id,
    comment: c.comment,
    type: c.type,
    created_at: c.createdAt,
    updated_at: c.updatedAt,
    user: {
      id: c.user.id,
      employee: {
        id: c.user.employee.id,
        first_name: c.user.employee.firstName,
        last_name: c.user.employee.lastName,
        display_first_name: c.user.employee.displayFirstName,
        display_last_name: c.user.employee.displayLastName,
      },
    },
  }))
